import React, { PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { FormattedMessage } from 'react-intl';

class SimpleDialog extends React.Component {
  static propTypes = {
    additionalActions: PropTypes.arrayOf(PropTypes.node),
    onSubmit: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.node
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit();
    }
    this.handleClose();
  };

  render() {
    let { children, title, open, additionalActions } = this.props;

    const actions = [
      <FlatButton
        label={<FormattedMessage id="dialog.cancel" defaultMessage="Cancel"/>}
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label={<FormattedMessage id="dialog.submit" defaultMessage="Submit"/>}
        primary={true}
        onClick={this.handleSubmit}
      />
    ].concat(additionalActions);

    return (
      <div>
        <Dialog
          title={title}
          actions={actions}
          modal={false}
          open={open}
//          onRequestClose={this.handleClose}
        >
          {children}
        </Dialog>
      </div>
    );
  }
}

SimpleDialog.defaultProps = {
  open:false
};

export default SimpleDialog;




// WEBPACK FOOTER //
// ./src/components/form/SimpleDialog.jsx